// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import Fader from '../js_vendor/Fader.js';
import * as Vars from './0-vars.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// exported variables ---------------------------------------------------------
export let fader;
export let pageTypePrev = sessionStorage.getItem('pageType');
document.body.setAttribute('data-pagetype-prev', pageTypePrev);
sessionStorage.setItem('pageType', $pageType);

// local variables ------------------------------------------------------------
const browserColorEl = document.querySelector('.browser-color');

// once function --------------------------------------------------------------
export const initOnce = () => {
  // console.log('once');

  // delay so fader classes are already given in page js on page load
  // can't be requestAnimationFrame because if you open in a new tab, there is no new frame
  setTimeout(() => {
    // incorrent when using back buttons, because DOMcontentLoaded is fired before pagereveal
    // console.log('window.blPageTransition', window.blPageTransition); 
    // alert(window.blPageTransition ? 'Page transition' : 'No page transition');

    // add Fader
    fader = new Fader({
      fadeOnInit: false,
      // mobileMq: '(orientation: portrait)',
      fadeDur: 1200,
      // preFadeResizeDur: 200,
      // afterLoadFunction: Resize.saveOffsets, 
      skipOnLoadInView: window.blPageTransition,
    });
  }, 0); // less than page js fader delay

  // save $pageType in sesstionStorage

  // output name for devvers ----------------------------------
  console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
  console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};

// functions -------------------------------------------------------------------

// so observers don't call resize while animating, which slows down the animation
export const observerBlocker = () => {
  // console.log('observerBlocker');
  Resize.setBlockResizeObserver(true); 
  if (typeof fader !== 'undefined' && fader) fader.blockResizeObserver = true;
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = true;
};

export const observerUnblocker = () => {
  // console.log('observerUnblocker');  
  Resize.setBlockResizeObserver(false);
  Resize.setResize(true);
  if (typeof fader !== 'undefined' && fader) fader.blockResizeObserver = false;
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = false;
}

const frameHandler = () => {
  // console.log('frameHandler');

  // browser color
  if (browserColorEl) {
    const background = getComputedStyle(browserColorEl).getPropertyValue('background-color');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
  }
};
